import script from "./StepBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepBox.vue?vue&type=script&setup=true&lang=ts"

import "./StepBox.vue?vue&type=style&index=0&id=ff124986&lang=scss"

const __exports__ = script;

export default __exports__